const ANALYTICS_SCRIPT_ID = '8faf5f3f-83a5-4742-882c-8ad22474585f'
const PULSE_CHAT_ID = '6854199f638a2074090fe4f3'
const SENDPULSE_FORM_ID = '392bb737e04e2ed4e2fe42c49200442cacdea57e1c67a30481aa768948253028'

export const CONSENT_VERSION = '2.0'

export function getCookieConsent() {
  try {
    return JSON.parse(localStorage.getItem('cookie_consent') || 'null')
  } catch {
    return null
  }
}

export function isConsentCurrent() {
  return getCookieConsent()?.version === CONSENT_VERSION
}

export function hasAnalyticsConsent() {
  return getCookieConsent()?.analytics === true
}

export function hasCommunicationConsent() {
  return getCookieConsent()?.communication === true
}

export function loadAnalyticsScript() {
  if (document.querySelector(`script[data-project-id="${ANALYTICS_SCRIPT_ID}"]`)) {
    return
  }

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://spxl.supportsrc.com/pulsepix.js'
  script.setAttribute('data-project-id', ANALYTICS_SCRIPT_ID)
  document.body.appendChild(script)
}

export function loadPulseChatScript() {
  if (document.querySelector('script[src*="pulse.is/livechat/loader.js"]')) {
    return
  }

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://cdn.pulse.is/livechat/loader.js'
  script.setAttribute('data-live-chat-id', PULSE_CHAT_ID)
  document.body.appendChild(script)
}

export function loadSendPulseScript() {
  if (document.querySelector('script[src*="webformscr.com"]')) {
    return
  }

  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  script.src = '//web.webformscr.com/apps/fc3/build/loader.js'
  script.setAttribute('sp-form-id', SENDPULSE_FORM_ID)
  document.head.appendChild(script)
}

export function initAnalyticsIfConsented() {
  if (hasAnalyticsConsent()) {
    loadAnalyticsScript()
  }
}

export function initCommunicationIfConsented() {
  if (hasCommunicationConsent()) {
    loadPulseChatScript()
  }
}

export function enableCommunication() {
  loadPulseChatScript()
  window.dispatchEvent(new CustomEvent('communication-consent-granted'))
}
